<div class="p-4 p-lg-5" style="overflow-wrap: anywhere;">
    <div class="vstack gap-5">
        <section class="text-center mx-auto" style="max-width: 48rem;">
            <h3 class="fw-semibold mb-2">
                Thanks, your voucher order has been received.
            </h3>
            <p class="text-muted mb-0 fs-6">
                We've received your order and will be processing it shortly.
            </p>
        </section>

        @if (sku !== null) {
            <section class="vstack gap-4">
                <div class="d-flex justify-content-center">
                    <div class="w-100" style="max-width: 520px;">
                        @for (lineItemViewModel of voucherLineItemViewModels; track lineItemViewModel.lineItem.id; let first = $first) {
                            <div
                                class="d-flex justify-content-center"
                                [class.border-top]="!first"
                                [class.pt-4]="!first"
                            >
                                <app-voucher-card
                                    class="d-flex w-100 justify-content-center"
                                    [venue]="venue"
                                    [voucher]="voucher"
                                    [sku]="lineItemViewModel.sku"
                                >
                                </app-voucher-card>
                            </div>
                        }
                    </div>
                </div>
            </section>
        }

        <div class="row g-5 align-items-start">
            <div class="col-lg-6">
                <section class="border-top pt-4">
                    <div class="vstack gap-3">
                        <h5 class="fw-semibold mb-0">
                            Delivery details
                        </h5>
                        <div class="vstack gap-1">
                            <span class="fw-semibold">
                                {{ deliveryMethodLabel }}
                            </span>
                            <p class="text-muted mb-0">
                                {{ deliveryLeadText }}
                            </p>
                        </div>
                        @if (hasPostalDelivery) {
                            <address class="mb-0 vstack gap-1 text-muted fst-normal">
                                @if (deliveryRecipientName) {
                                    <span class="text-body fw-semibold">
                                        {{ deliveryRecipientName }}
                                    </span>
                                }
                                @for (line of postalAddressLines; track line) {
                                    <span>{{ line }}</span>
                                }
                            </address>
                        } @else if (hasEmailDelivery) {
                            <span class="fw-semibold">
                                {{ deliveryEmailAddress }}
                            </span>
                        }
                    </div>
                </section>

                <section class="border-top pt-4 mt-4">
                    <div class="vstack gap-2">
                        <h5 class="fw-semibold mb-0">
                            What happens next
                        </h5>
                        <div class="vstack gap-2 text-muted">
                            @if (hasPostalDelivery) {
                                <p class="mb-0">
                                    {{ venue.voucherDisplayName() }} will prepare the voucher and post it to the recipient.
                                </p>
                            } @else {
                                <p class="mb-0">
                                    The voucher will be emailed to the recipient.
                                </p>
                            }
                            <p class="mb-0">
                                Please contact {{ venue.voucherDisplayName() }} directly if you need to change any order details.
                            </p>
                        </div>
                    </div>
                </section>
            </div>

            <div class="col-lg-6">
                <section class="border-top pt-4">
                    <div class="vstack gap-3">
                        <h5 class="fw-semibold mb-0">
                            Order summary
                        </h5>
                        @for (lineItemViewModel of lineItemViewModels; track lineItemViewModel.lineItem.id) {
                            @let lineItem = lineItemViewModel.lineItem;
                            <div class="d-flex gap-3 justify-content-between align-items-start">
                                <div class="vstack gap-1">
                                    <span class="fw-semibold">
                                        {{ lineItem.name }}
                                    </span>
                                    <span class="text-muted small">
                                        {{ lineItem.quantity }} x {{ null | currencyUnit : lineItem.amount : sale.order.currencyCode }}
                                    </span>
                                </div>
                                <span class="fw-semibold text-nowrap">
                                    {{ null | currencyUnit : lineItemViewModel.total : sale.order.currencyCode }}
                                </span>
                            </div>
                        }
                        <hr class="m-0 border-dark-subtle"/>
                        <div class="vstack gap-2">
                            <div class="d-flex justify-content-between gap-3">
                                <span class="text-muted">
                                    Subtotal
                                </span>
                                <span>
                                    {{ null | currencyUnit : orderTotal : sale.order.currencyCode }}
                                </span>
                            </div>
                            <div class="d-flex justify-content-between gap-3">
                                <span class="fw-semibold">
                                    Total
                                </span>
                                <span class="fw-semibold fs-5">
                                    {{ null | currencyUnit : orderTotal : sale.order.currencyCode }}
                                </span>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>
